export const validationPatterns = {
    baseNamePattern: '^[A-Za-z0-9äöüÄÖÜß._\\- ]*$',
    phonePattern: '[- +()0-9]*',
    namePattern: "[a-zA-ZÄÖÜäöüß '-]*",
    alphaNumericPointMinusUnderScoreBlankPattern: `^[A-Za-z0-9-_. ]*$`,
    extendedNamePattern:
        "^[A-Za-zßÄäÖöÜüàâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ'\\s.-]*$",
};
